import { AutocompleteState, BaseItem } from "@algolia/autocomplete-core";

export const getRedirectUrlFromState = <TItem extends BaseItem>(
    state: Partial<AutocompleteState<TItem>>,
) =>
    (state?.context?.redirectUrlPlugin?.data ?? [])
        .flatMap(({ urls }) => urls)
        .at(0);
